module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAAKpJREFUSA1jbLj6tc5QmKOWn5WJhYEO4OPvf3/Ov/3RzLjxxd/fc6+/Z7n07icdrGVg0BNiZ0jWFPzDAvIpyNL7QVJ0sVhx3TMGkJ1MdLENiyWjFmMJFNoIjQY1bcIVi6mjQY0lUGgjNBrUtAlXLKaOBjWWQKGN0GhQ0yZcsZg6GtRYAoU2QqNBTZtwxWIqC6gvA+xWsIBa+PQAoC4MyE4WUAcK2Jehe6cNAF1PMSJUc0b6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/images/common_icon_n_2.png
// module id = 846
// module chunks = 124